module.exports = __webpack_public_path__ + "static/media/bathroom-scheme-light.aab29adb.jpeg";